import React from 'react';
import text from '../../images/textWhite.svg';
import lcon from '../../images/iconWhite.svg';
import { useNavigate } from 'react-router-dom';
const RoutbillingHomeLogo = ({open}) => {
 
  return (
    <div className=" flex  justify-center items-center">
      {!open &&  <img
        src={lcon}
        style={{
          width: '30px',
          height: 'auto',
        }}
      />}
     
      <img
        src={text}
        style={{
          width: '140px',
          height: 'auto',
        }}
        className="ml-[8px]"
      />
    </div>
  );
};

export default RoutbillingHomeLogo;
